import { RELATION_TYPE, BLOOD_TYPE } from '@/config/common'
export function formatPrice(val, keepPoint = true) {
  const priceArr = (val / 100).toFixed(2).split('.')
  if (keepPoint) {
    return priceArr[0] + '.' + priceArr[1]
  } else {
    return Number(priceArr[0] + '.' + priceArr[1])
  }
}

export function relationDict(val) {
  const dict = RELATION_TYPE.find((item) => {
    return +item.value === +val
  })
  return dict
}
export function bloodTypeDict(val) {
  const dict = BLOOD_TYPE.find((item) => {
    return +item.value === +val
  })
  return dict
}
